import { Component, OnInit, ComponentFactoryResolver, ViewContainerRef, Input } from '@angular/core';

@Component({
    selector: 'side-panel-dynamic',
    templateUrl: './side-panel-dynamic.component.html',
    styleUrls: ['./side-panel-dynamic.component.css'],
    standalone: false
})
export class SidePanelDynamicComponent implements OnInit {
    @Input() public RefSidePanelComponent: any;

    constructor(
        private viewRef: ViewContainerRef,
        private componentResolver: ComponentFactoryResolver
    ) {}

    ngOnInit() {
        if (this.RefSidePanelComponent) {
            this.viewRef.createComponent(this.RefSidePanelComponent);
        } else {
            this.viewRef.clear();
        }
    }
}
